/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx, cssMap as unboundedCssMap } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { SmallErrorState, type SmallErrorStateProps } from '@atlassian/company-hub-common';

const styles = unboundedCssMap({
	container: {
		overflow: 'hidden',
		boxShadow: token('elevation.shadow.raised'),
		borderRadius: token('radius.large'),
	},
	viewMode: {
		'&:hover': {
			boxShadow: `0px 5px 12px 0px ${token('color.border')}`,
			cursor: 'pointer',
		},
	},
});

type SmallCardErrorStateProps = {
	height?: number;
	isInViewMode?: boolean;
	itemId?: string;
} & SmallErrorStateProps;

export const SmallCardErrorState = ({
	itemId,
	height,
	isInViewMode,
	...props
}: SmallCardErrorStateProps) => {
	return (
		<div
			data-testid="small-card-error-state"
			id={itemId}
			css={[styles.container, isInViewMode && styles.viewMode]}
			style={{ height: height }}
		>
			<SmallErrorState {...props} />
		</div>
	);
};
